import * as amplitude from '@amplitude/analytics-browser';

let initialized = false;

export const initAmplitude = () => {
  if (initialized) return;

  amplitude.init('b59ea60adec108baf580273d9da0d525', {
    defaultTracking: {
      sessions: true,
      pageViews: true, // ← pageviews automáticos globais
    },
  });

  initialized = true;
};
